/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

//table imports
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";

//icons
import Delete from "@mui/icons-material/Delete";

import { withTranslation } from "react-i18next";

import { Grid, Card } from "@mui/material";
import Input from "../../../component/inputpm";
import { Tooltip } from "@mui/material";
import { IconButton, FormControl, Select } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import classes from "../createPackage/createPackage.module.css";
import Button from "../../../component/button";
import { Checkbox } from "@mui/material";
import { MenuItem } from "@mui/material";
import { ListItemText } from "@mui/material";
import OriginalInput from "@mui/material/Input";

const EnrichmentConfig = (props) => {
  useEffect(() => {});
  const t = props.t;
  const getChannelName = (id) => {
    var index = props.channelList.findIndex((c) => c.id === id);
    if (index > -1) {
      return props.channelList[index].value;
    } else {
      return "";
    }
  };
  const filterChannelList = (id) => {
    var data = props.data;
    if (data.length > 0) {
      var index = data.findIndex((d) => d.id === id);
      if (index > -1) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };
  return (
    <React.Fragment>
      <Grid container spacing={3}>
        {props.readonlyMode ? (
          ""
        ) : (
          <>
            <Grid
              item
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <FormControl
                variant="outlined"
                size={"small"}
                className={"customeSelectLabel"}
              >
                <Select
                  value={props.selectedEnrichmentChannel}
                  native
                  onChange={(e) =>
                    props.selectEnrichmentChannel(
                      e.target.value,
                      props.parentId,
                    )
                  }
                  inputProps={{
                    name: "id",
                    id: "id",
                  }}
                  disabled={props.disableInputfields}
                >
                  <option value="">Select Channel</option>
                  {props.channelList &&
                    props.channelList.map(
                      (option, e) =>
                        filterChannelList(option.id) && (
                          <option key={e} value={option.id}>
                            {option.value}
                          </option>
                        ),
                    )}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 6,
              }}
            >
              {!props.disableInputfields && (
                <Button onClick={() => props.addEnrichmentRow(props.parentId)}>
                  {t("ADD")}
                </Button>
              )}
            </Grid>
          </>
        )}

        <Grid
          item
          size={{
            xs: 12,
          }}
        >
          <Card
            variant="outlined"
            style={{ borderRadius: "8px", marginBottom: "40px" }}
          >
            <TableContainer>
              <Table className="newGlobalTable roundCorners">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>{t("CHANNEL")}</b>
                    </TableCell>
                    <TableCell style={{ width: 80 }} align="center">
                      <b>{t("PURCHASE")}</b>
                    </TableCell>
                    <TableCell style={{ width: 80 }} align="center">
                      <b>{t("REMOVE")}</b>
                    </TableCell>
                    <TableCell style={{ width: 80 }} align="center">
                      <b>{t("RE_PURCHASE")}</b>
                    </TableCell>
                    <TableCell style={{ width: 80 }} align="center">
                      <b>{t("VISIBLE")}</b>
                    </TableCell>
                    {props.readonlyMode ? (
                      ""
                    ) : (
                      <TableCell style={{ width: 30 }}></TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.data &&
                    props.data.length > 0 &&
                    props.data.map((item, i) => (
                      <TableRow key={i}>
                        <TableCell>{getChannelName(item.id)}</TableCell>
                        <TableCell align="center">
                          <Checkbox
                            value={item.purchaseable}
                            checked={item.purchaseable}
                            onChange={(e) =>
                              props.onChange(e, i, props.parentId)
                            }
                            color="primary"
                            name={"purchaseable"}
                            disabled={
                              props.readonlyMode || props.disableInputfields
                            }
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox
                            value={item.removeable}
                            checked={item.removeable}
                            onChange={(e) =>
                              props.onChange(e, i, props.parentId)
                            }
                            color="primary"
                            name={"removeable"}
                            disabled={
                              props.readonlyMode || props.disableInputfields
                            }
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox
                            value={item.rePurchaseable}
                            checked={item.rePurchaseable}
                            onChange={(e) =>
                              props.onChange(e, i, props.parentId)
                            }
                            color="primary"
                            name={"rePurchaseable"}
                            disabled={
                              props.readonlyMode || props.disableInputfields
                            }
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox
                            value={item.visible}
                            checked={item.visible}
                            onChange={(e) =>
                              props.onChange(e, i, props.parentId)
                            }
                            color="primary"
                            name={"visible"}
                            disabled={
                              props.readonlyMode || props.disableInputfields
                            }
                          />
                        </TableCell>
                        {props.readonlyMode || props.disableInputfields ? (
                          ""
                        ) : (
                          <TableCell align="center">
                            <Tooltip title={t("DELETE")}>
                              <Delete
                                onClick={() =>
                                  props.deleteEnrichment(i, props.parentId)
                                }
                              />
                            </Tooltip>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  {props.data && props.data.length === 0 && (
                    <TableRow>
                      <TableCell align="center" colSpan={6}>
                        {t("NO_ENRICHMENT_CONFIG")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {};
};
export default connect(mapStateToProps)(
  withTranslation("translations")(EnrichmentConfig),
);
